<template>
  <div class="quoteDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.salesManagement.title1 }}</div>

      <van-field
        v-model="form.QuotationRefNumber"
        :label="$t.salesManagement.qrNumber"
        label-class="number-label"
        readonly
        v-if="form.QuotationRefNumber"
      >
        <template #button>
          <van-button size="small" type="info" @click="onCopy(form.QuotationRefNumber)">{{
            $t.meta.copy
          }}</van-button>
        </template>
      </van-field>

      <van-field
        v-model="form.CompanyName"
        :label="$t.salesManagement.enterprise"
        type="textarea"
        rows="3"
        disabled
      />

      <van-field
        v-model="form.BusinessTypeStr"
        :label="$t.salesManagement.businessType"
        disabled
      />

      <van-field
        v-model="form.PhoneNumber"
        :label="$t.salesManagement.initiationPhone"
        disabled
      />

      <van-field
        v-model="form.CreateTime"
        :label="$t.salesManagement.initiationTime"
        disabled
      />

      <div class="title">{{ $t.salesManagement.title2 }}</div>

      <van-field
        v-model="form.GoodsName"
        :label="$t.salesManagement.goodsName"
        disabled
      />

      <van-field v-model="form.TCName" :label="$t.salesManagement.tradeTerms" disabled />

      <van-field
        v-model="form.NumberPackages"
        :label="$t.salesManagement.pNumber"
        disabled
      />

      <van-field v-model="form.Volume" :label="$t.salesManagement.volume" disabled />

      <van-field v-model="form.Weight" :label="$t.salesManagement.weight" disabled />

      <van-field
        v-model="form.CreateTime"
        :label="$t.salesManagement.createTime"
        disabled
      />

      <van-field
        v-model="form.DeliveryCountryCity"
        :label="$t.salesManagement.delivery"
        disabled
      />

      <van-field
        v-model="form.DestinationCountryCity"
        :label="$t.salesManagement.destination"
        disabled
      />

      <div class="quote-detail-radio">
        <div class="radio-label">{{ $t.salesManagement.brand }}</div>
        <van-radio-group v-model="form.Brand" direction="horizontal" disabled>
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="quote-detail-radio">
        <div class="radio-label">{{ $t.salesManagement.liquid }}</div>
        <van-radio-group v-model="form.Liquid" direction="horizontal" disabled>
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="quote-detail-radio">
        <div class="radio-label">{{ $t.salesManagement.powder }}</div>
        <van-radio-group v-model="form.Powder" direction="horizontal" disabled>
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="quote-detail-radio">
        <div class="radio-label">{{ $t.salesManagement.magnetic }}</div>
        <van-radio-group v-model="form.Magnetic" direction="horizontal" disabled>
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="quote-detail-radio">
        <div class="radio-label">{{ $t.salesManagement.export1 }}</div>
        <van-radio-group v-model="form.AgentExport" direction="horizontal" disabled>
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="quote-detail-radio">
        <div class="radio-label">{{ $t.salesManagement.export2 }}</div>
        <van-radio-group v-model="form.ExportRebates" direction="horizontal" disabled>
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="quote-detail-radio">
        <div class="radio-label">{{ $t.salesManagement.export3 }}</div>
        <van-radio-group v-model="form.Import" direction="horizontal" disabled>
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <van-field v-model="form.ECDName" :label="$t.salesManagement.commission" disabled />

      <div class="quote-detail-radio">
        <div class="radio-label">{{ $t.salesManagement.tdService }}</div>
        <van-radio-group
          v-model="form.TakeDeliveryService"
          direction="horizontal"
          disabled
        >
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <van-field
        v-model="form.TakeDeliveryCountryCity"
        :label="$t.salesManagement.takeDeliveryCity"
        disabled
      />

      <van-field
        v-model="form.TakeDeliveryAddress"
        :label="$t.salesManagement.takeDeliveryAddress"
        disabled
        type="textarea"
      />

      <div style="margin: 16px">
        <van-button round block type="info" @click="gotoCreate">{{
          $t.salesManagement.addQuotation
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Radio, RadioGroup } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(Radio).use(RadioGroup);

export default {
  name: "quoteDetail",
  data() {
    return {
      QRId: "",
      form: {},
    };
  },
  created() {
    const { QRId } = this.$route.query;
    if (QRId) {
      this.QRId = QRId;
      this.getQuotationReferenceInfo();
    }
  },
  methods: {
    gotoCreate() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quoteCreate",
        name: "quoteCreate",
        query: [
          {
            name: "QRId",
            value: this.form.QRId,
          },
          {
            name: "QuotationRefNumber",
            value: this.form.QuotationRefNumber,
          },
          {
            name: "Type",
            value: "unquote",
          },
        ],
      });
    },
    getQuotationReferenceInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          QRId: this.QRId,
        };
        this.$api.salesManagement
          .getQuotationReferenceInfo(param)
          .then((res) => {
            this.form = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.quoteDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #999 !important;
    -webkit-text-fill-color: #999 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  .quote-detail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #999;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      font-size: 14px;
    }
  }
}
</style>
